<template>
  <div>
    <b-modal
        id="delete-break-code"
        ref="delete-break-code"
        size="entry-delete"
        centered
        hide-footer
        hide-header
        @hide="cancel"
    >
      <div class="modal-head">
        <span class="modal-title">{{ label.get('delete_break_rule') }}</span>
      </div>
      <div class="content-wrapper">
        <div class="field-row">
          <p v-html="label.get('delete_modal_body', {name: label.get('break_preferences_break_rule')})" />
        </div>
      </div>
      <div class="modal-footer">
        <button
            class="cancel atto-btn"
            @click="cancel"
        >
          {{ label.get('cancel') }}
        </button>
        <button
            class="atto-btn delete"
            :disabled="disabledSaveButton"
            @click="deleteBreakCode"
        >
          {{ label.get('delete') }}
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BreakPreferencesService from "../services/BreakPreferencesService";

export default {
  name: "DeleteBreakCodeComponent",
  props: {
    breakCode: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      disabledSaveButton: false
    }
  },
  mounted(){
    document.body.appendChild(this.$el);
    this.$refs['delete-break-code'].show();
  },
  methods: {
    deleteBreakCode(){
      this.disabledSaveButton = true;
      BreakPreferencesService.deleteBreakCode(this.breakCode.id).then((response) => {
        this.$awn.success(response.message);
        this.$root.$emit("hideDeleteBreakCode", this.breakCode);
      }).catch((error) => {
        this.disabledSaveButton = false;
        console.log('Error while deleting Break Code!');
      });
    },
    cancel(){
      this.$root.$emit("hideDeleteBreakCode");
    }
  }
}
</script>

<style scoped>

</style>